import main from './Main'

export default {
  main,
}
